export default __webpack_public_path__ + "static/media/maqui_head.6999e4f6.png";